<script>
  import { onMount } from "svelte";
  import { result } from "../store.js";
  import datepicker from "js-datepicker";
  import "js-datepicker/dist/datepicker.min.css";

  export let item = {
    type: "date",
    required: false,
    title: "",
    description: "",
    placeholder: "",
  };
  export let index = 0;
  export let current = 0;

  onMount(() => {
    $result[index] = "";
    const picker = datepicker("#date", {
      onSelect: (instance, date) => {
        // Do stuff when a date is selected (or unselected) on the calendar.
        // You have access to the datepicker instance for convenience.
        $result[index] = date.toDateString();
      },
      onShow: () => {
        if (index === current)
          document.getElementById("main").style.paddingBottom = "120px";
      },
      onHide: () => {
        if (index === current)
          document.getElementById("main").style.paddingBottom = "1rem";
      },
    });
    picker.calendarContainer.style.setProperty("width", "100%");
  });
</script>

<input
  id="date"
  autocomplete="off"
  readonly
  required={item.required}
  placeholder={item.placeholder || ""}
/>

<style>
  input {
    width: 100%;
  }
</style>
